import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/codebuild/output/src2010298565/src/actions-runner/builds/8n8xKsbem/0/scheinone/jarvis/scheduler/frontend/node_modules/css-loader/dist/runtime/api.js'
import '/codebuild/output/src2010298565/src/actions-runner/builds/8n8xKsbem/0/scheinone/jarvis/scheduler/frontend/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/codebuild/output/src2010298565/src/actions-runner/builds/8n8xKsbem/0/scheinone/jarvis/scheduler/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js'

import jarvisSchedulerV2 from '~root/src/App.vue?shadow'
window.customElements.define('jarvis-scheduler-v2', wrap(Vue, jarvisSchedulerV2))